import { capitalize } from '@sorrem-client/ui/shared/text';
import type { EssenceType } from '@sorrem/shared';
import { EssenceOrb } from '@sorrem-client/ui/components/EssenceOrb';
import styles from './EssenceVesselEntry.module.scss';

interface EssenceVesselEntryProps {
    /** The essence type, which sets the orb's color and the label. */
    type: EssenceType;
    /** The amount of this essence. */
    value: number;
}


/**
 * One essence type in the vessel: a row of the orb tinted the essence color
 * and the value, with the type's name centered under the row.
 */
export function EssenceVesselEntry({ type, value }: EssenceVesselEntryProps): JSX.Element {
    return (
        <li className={styles.essenceVesselEntry}>
            <span className={styles.row}>
                <EssenceOrb type={type} className={styles.orb} />
                <span className={styles.value}>{value.toLocaleString()}</span>
            </span>
            <span className={styles.label}>{capitalize(type)}</span>
        </li>
    );
}
